import Http from '../libs/http';

export default {

  // 保险商品详情
  insuranceDetails(params) {
    return Http.post('/sys/insurance_details', params);
  },

  // 保险商品详情
  BusinessinsuranceDetails(params) {
    return Http.post('/insurance_detail_query', params);
  },

  // 保险商品价格试算
  insuranceSimpleTrial(params) {
    return Http.post('/sys/insurance_simple_trial', params);
  },

  // 保险下单预提交
  insurancePreSubmit(params) {
    return Http.post('/insurance_pre_submit', params);
  },

  // 保险订单详情
  insuranceOrderQuery(params) {
    return Http.post('/insurance_order_query', params);
  },

  // 保险下单
  simpleInsure(params) {
    return Http.post('/simple_insure', params);
  },

  // 保险订单支付
  insuranceOrderPay(params) {
    return Http.post('/insurance_order_pay', params);
  },

  // 保险订单列表
  insuranceOrderBriefQuery(params) {
    return Http.post('/insurance_order_brief_query', params);
  },

  // 保险订单取消
  insuranceOrderCancel(params) {
    return Http.post('/insurance_order_cancel', params, { noToast: true });
  },

  // 保险订单下载
  insuranceDownload(params) {
    return Http.post('/insurance_download', params);
  },

  // 保险订单删除
  insuranceOrderDelete(params) {
    return Http.post('/insurance_order_delete', params);
  },

  // 开发和测试环境要手动调用支付成功的回调
  paySuccessCallBack(url) {
    return Http.post('/open/qixin_cps_callback', 
      {
        data: {
          caseCode: 'QX000000128998',
          insureNum: '20250117014372',
          partnerId: 1012808,
          state: true,
        },
        notifyType: 4, // 通知类型，表示某种回调状态
        sign: '73cf628ba73e999bbfa985cfa809b4da', // 签名
      },
      {
        url,
      },
    );
  },

  paySuccessCallBackAgain(insureNum, url) {
    return Http.post('/open/qixin_cps_callback', 
      {
        data: {
          caseCode: 'QX000000128998',
          insureNum,
          partnerId: 1012808,
          policys: [
            {
              applicant: '深圳市六六六国际旅行社有限公司',
              endDate: '2025-03-04',
              insurant: '陈和',
              planId: 128998,
              planName: '经济款',
              policyNum: '21030000894250002846',
              productId: 104192,
              productName: '安盛天平安享天下境外旅游保险',
              startDate: '2025-02-28',
            },
          ],
          state: true,
        },
        notifyType: 3,
        sign: 'c44b85b2cc2e96b4b0b8d524f45aee4f',
      },
      { url },
    );
  },

};



// WEBPACK FOOTER //
// ./src/api/insurance-api.js